import { AppSwitcherMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/AppSwitcherMenu/AppSwitcherMenu";

export { AppSwitcherMenu };
